import React from 'react';
import { useUrlState } from '../hooks/useUrlState';
import VirtualTableExperiment from './VirtualTableExperiment';
import UploadFormRestore from './experiments/UploadFormRestore';
import PageSplitSample from './experiments/PageSplitSample';
import BusinessPlanCharts from './experiments/BusinessPlanCharts';
import './Experiments.css';

// 실험실 — 검증 중인 것들만 모아 둔다. 확정되면 정식 화면으로 옮기고 여기서 뺀다.
// 새 실험은 이 배열에 항목만 추가하면 된다. GNB에는 노출하지 않는다(/experiments 직접 접근).
const EXPERIMENTS = [
  {
    id: 'upload-form-restore',
    icon: '📥',
    title: '업로드 양식으로 되돌리기',
    description: 'DB에 저장된 임금대장을 최신 업로드 양식에 수식을 살린 채 복원',
    features: ['입력 컬럼만 채우고 수식은 유지', '수당 자리·요율 자동 정리', '못 되돌린 것은 사용자노트로 고지'],
    Comp: UploadFormRestore,
  },
  {
    id: 'virtual-table',
    icon: '⚡',
    title: '가상 스크롤 테이블',
    description: '임금대장 다단계 헤더를 보이는 행만 렌더링해 체감 성능 확인',
    features: ['실제 업로드 데이터 사용', '프로덕션 화면과 분리'],
    Comp: VirtualTableExperiment,
  },
  {
    id: 'page-split',
    icon: '📄',
    title: '문서 Page-split 샘플',
    description: '긴 문서가 A4 페이지 단위로 자동 분할되는지 확인',
    features: ['자동 분할', '강제 페이지 분리'],
    Comp: PageSplitSample,
  },
  {
    id: 'business-plan',
    icon: '📊',
    title: '사업계획 차트',
    description: '플랜별 가격·고객 수·매출과 시장 규모(TAM/SAM/SOM)',
    features: ['하드코딩된 예시 데이터'],
    Comp: BusinessPlanCharts,
  },
];

function Experiments() {
  // 연 실험은 주소에 둔다(?id=…)
  const [url, setUrl] = useUrlState();
  const activeId = url.get('id');
  const setActiveId = (id) => setUrl({ id });
  const active = EXPERIMENTS.find(x => x.id === activeId);

  if (active) {
    const { Comp } = active;
    return (
      <div className="experiments-page">
        <div className="experiments-header">
          <button type="button" className="experiments-back" onClick={() => setActiveId(null)}>
            ← 목록
          </button>
          <h2 className="experiments-title">{active.icon} {active.title}</h2>
        </div>
        <Comp />
      </div>
    );
  }

  return (
    <div className="experiments-page">
      <div className="experiments-hub-intro">
        <h2>실험실</h2>
        <p>
          검증 중인 기능들입니다. 결과가 확정되면 정식 화면으로 옮깁니다.<br />
          실제 데이터를 다루는 항목이 있으니 결과를 그대로 신뢰하지 마세요.
        </p>
      </div>

      <div className="experiments-hub-cards">
        {EXPERIMENTS.map(item => (
          <div key={item.id} className="experiments-hub-card" onClick={() => setActiveId(item.id)}>
            <div className="experiments-hub-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <ul>
              {item.features.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Experiments;
